import React from "react";
import { SanityImageRatio } from "../ImageRatio/SanityImageRatio";
import { ResponsiveSanityImage } from "../ResponsiveSanityImage/ResponsiveSanityImage";
import { SanityImageType } from "../SanityImage";
import styles from "./ImageValue.module.scss";

type Props = {
  image: SanityImageType;
};

export const ImageValue: React.FC<React.PropsWithChildren<Props>> = ({
  image
}) => {
  return (
    <div>
      <div className={styles.wrapper}>
        <SanityImageRatio ratio="card">
          <ResponsiveSanityImage
            image={image}
            defaultWidth={400}
            defaultHeight={300}
            fit="original"
          />
        </SanityImageRatio>
      </div>
    </div>
  );
};
